import React, { useState } from 'react';
import { Modal, ModalType } from './Modal';
import QuranInfo from './info_components/QuranInfo';
import AppInfo from './info_components/AppInfo';
const NavBar = ({ children }) => {
  const [isNavOpen, toggleNav] = useState(false);
  const [isSubLibraryNavNavOpen, toggleSubLibraryNav] = useState(true);
  const [modalData, updateModalData] = useState({ isOpen: false });
  const handleOpenModal = type => {
    //alert(type);
    let newModalData = {};

    switch (type) {
      case ModalType.APP_FEEDBACK:
        newModalData = {
          ...modalData,

          title: `أكتب رأيك حول التطبيق `,
          data: ''
        };
        break;
      case ModalType.APP_HOW_TO_USE:
        newModalData = {
          ...modalData,

          title: `كيفية الاستخدام `,
          data: ''
        };
        break;
      case ModalType.QURAN_INFO:
        newModalData = {
          ...modalData,

          title: `معلومات حول القرآن الكريم `,
          data: ''
        };
        break;
      case ModalType.COMMUNICATE_WITH_US:
        newModalData = {
          ...modalData,

          title: `تواصل معنا `,
          data: ''
        };
        break;
      case ModalType.APP_ABOUT:
        newModalData = {
          ...modalData,

          title: `معلومات حول التطبيق `,
          data: ''
        };
        break;

      default:
        console.log('default case modal type');
        newModalData = {
          ...modalData,
          title: 'UNKNOWN',
          data: ''
        };
    }
    newModalData.isOpen = true;
    newModalData.ModalType = type;
    updateModalData(newModalData);
  };
  const modalContent = () => {
    switch (modalData.ModalType) {
      case ModalType.APP_FEEDBACK:
        return (
          <>
            <button
              className="button"
              onClick={e => {
                var url = 'https://www.facebook.com/nacersalaheddine05/';
                window.open(url, '_blank');
              }}
            >
              <span className="icon is-medium">
                <i className="fa fa-send" />
              </span>
              <span style={{ direction: 'rtl' }}>تواصل مع المطور 😊</span>
            </button>
          </>
        );

      case ModalType.APP_HOW_TO_USE:
        return (
          <video width="100%" controls>
            <source
              src="https://raw.githubusercontent.com/nacersalaheddine/quran-awesome-player/master/app_resources/quran%20awesome%20player%20sample%20video.mp4"
              type="video/mp4"
            />
            <source
              src="https://raw.githubusercontent.com/nacersalaheddine/quran-awesome-player/master/app_resources/quran%20awesome%20player%20sample%20video.mp4"
              type="video/ogg"
            />
            متصفحك لايدعم الفيديو
          </video>
        );
      case ModalType.COMMUNICATE_WITH_US:
        return (
          <>
            <button
              className="button"
              onClick={e => {
                var url = 'https://www.facebook.com/nacersalaheddine05/';
                window.open(url, '_blank');
              }}
            >
              <span className="icon is-medium">
                <i className="fa fa-send-o" />
              </span>
              <span style={{ direction: 'rtl' }}>تواصل مع المطور 😎</span>
            </button>
          </>
        );
      case ModalType.QURAN_INFO:
        return <QuranInfo />;
      case ModalType.APP_ABOUT:
        return <AppInfo />;
      default:
        console.log('default case modal type');
        return (
          <a
            href="https://www.facebook.com/nacersalaheddine05/"
            target="_blank"
          >
            Error, comunicate with Developer (Salah eddine, Nacer)
          </a>
        );
    }
  };
  return (
    <>
      <Modal modalData={modalData} updateModalData={updateModalData}>
        {modalData.data === '' ? modalContent() : ''}
      </Modal>
      <nav className="navbar is-fixed-top">
        <div className="navbar-brand">
          {children[0]}
          <a
            className="navbar-burger"
            onClick={() => {
              toggleNav(!isNavOpen);
            }}
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>
        <div
          id="navMenu"
          className={isNavOpen ? 'navbar-menu is-active' : 'navbar-menu'}
        >
          <div className="navbar-start">
            <div
              className={
                isSubLibraryNavNavOpen
                  ? 'navbar-item has-dropdown is-hoverable is-active-nav-item is-mobile-closed'
                  : 'navbar-item has-dropdown is-hoverable is-active-nav-item'
              }
            >
              <a
                className="navbar-link"
                onClick={() => {
                  toggleSubLibraryNav(!isSubLibraryNavNavOpen);
                }}
              >
                <span className="icon-text">
                  <span className="icon has-text-primary">
                    {' '}
                    <i className="fa fa-circle-o"> </i>&nbsp;{' '}
                  </span>
                  <span>تطبيق القـــــــرآن ￩ </span>
                </span>
              </a>
              {/*is-boxed */}
              <div className="navbar-dropdown">
                <a
                  className="navbar-item"
                  onClick={e => {
                    e.preventDefault();
                    handleOpenModal(ModalType.APP_FEEDBACK);
                  }}
                >
                  <b> مارايك حول التطبيق؟ </b>
                </a>
                <a
                  className="navbar-item"
                  onClick={e => {
                    e.preventDefault();
                    handleOpenModal(ModalType.APP_HOW_TO_USE);
                  }}
                >
                  <b> طريقة إستخدام التطبيق </b>
                </a>
                <hr className="navbar-divider" />
                <a
                  className="navbar-item"
                  onClick={e => {
                    e.preventDefault();
                    handleOpenModal(ModalType.APP_ABOUT);
                  }}
                >
                  حول التطبيق
                </a>
                <a
                  className="navbar-item"
                  onClick={e => {
                    e.preventDefault();
                    handleOpenModal(ModalType.QURAN_INFO);
                  }}
                >
                  <b> معلومات حول القرآن الكريم. </b>
                </a>
                <a
                  className="navbar-item "
                  onClick={e => {
                    e.preventDefault();
                    handleOpenModal(ModalType.COMMUNICATE_WITH_US);
                  }}
                >
                  تواصل ￩
                </a>
                <hr className="navbar-divider" />
                <a
                  className="navbar-item is-active"
                  onClick={e => {
                    e.preventDefault();
                  }}
                >
                  النسخة 0.1
                </a>
              </div>
            </div>

            <a className="navbar-item hvr">
              <span className="icon-text">
                <span className="icon has-text-danger">
                  {' '}
                  <i className="fa fa-magic"> </i>&nbsp;{' '}
                </span>
                <span>
                  برمجة من طرف{' '}
                  <em>
                    <b>صلاح الدين ناصر </b>
                  </em>
                  🤓{' '}
                </span>
              </span>
            </a>
            <div className="navbar-item">
              <div className="field">
                <p className="control has-icons-left has-icons-right">
                  {children[1]}
                </p>
              </div>
            </div>
          </div>
          <div className="navbar-end">
            <div className="navbar-item">
              <a
                className="button"
                href="https://www.facebook.com/nacersalaheddine05/"
                target="_blank"
              >
                <span className="icon is-small">
                  <i className="fa fa-facebook"> </i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
export default NavBar;
